import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand social-media-services p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <h2>
              Social Media <span>Marketing Services</span>
            </h2>
            <p>
              Are you all set to give a boost to your business and reach out to
              your target audience?
            </p>
            <p>
              Allow us to take your social media marketing campaign to the next
              level and turn your goals into reality.
            </p>
            <h4>Start with a Free Consultation</h4>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Contact us today to get started!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Instagram Marketing Services</h4>
                  <p>
                    Instagram is a social media platform primarily focused on
                    sharing photos and videos. Grow your business with a strong
                    presence on Instagram and attract thousands and millions of
                    followers through this exciting platform.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>TikTok Marketing Services</h4>
                  <p>
                    TikTok is another platform to give a boost to your online
                    presence. It is all about creating and sharing short videos
                    that are trending all over the world. Your business can stay
                    up to date with the trending TikToks and share a glimpse of
                    your organization with the target audience.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>LinkedIn Marketing Services</h4>
                  <p>
                    LinkedIn helps you market your products and services to
                    potential target audiences and also helps you differentiate
                    yourself from other competitors in any industry. Your
                    business profile on LinkedIn can help with brand awareness
                    through weekly newsletters and active interactions with
                    users who are interested in your products or services.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Facebook Marketing Services</h4>
                  <p>
                    Facebook is a public social media platform that acts as an
                    access point for you and your target audience. A business
                    Facebook account, helps you to stay connected with the users
                    on a day-to-day basis. It is a great platform for online
                    engagement with the audience and establishing brand
                    recognition for your business on a larger scale.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>X Marketing Services</h4>
                  <p>
                    X formerly known as Twitter, enables your business to stay
                    connected and up-to-date with whatever is trending all over
                    the world. X will not only connect you to your target
                    audience but also will help you stay ahead of your
                    competitors through an improved brand reputation.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>YouTube Marketing Services</h4>
                  <p>
                    Create an unforgettable performance for your brand with a
                    variety of video content through YouTube Marketing Services.
                    The most popular types of videos on YouTube include
                    explainer videos, sales videos, social media clips,
                    presentation videos, and video ads.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
